import Vue from 'vue';

export default {
    searchJobTitle(context, data) {
        const url = `v1/job-title-suggestions?keyword=${data}`;
        return Vue.$axios.$get(url);
    },

    searchJobsByUrl(context, params) {
        let url = 'v1/search-job';
        return Vue.$axios.$get(url, {params});
    },

    searchJobsByFilter(context, data) {
        const url = 'v1/search-job';
        return Vue.$axios.$post(url, data);
    },
};
